import { Box, Grid, styled, IconButton } from "@mui/material";
import { FlightCard } from "src/components/Flights/FlightCard";
import { FlightDropCard } from "src/components/Flights/FlightDropCard";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useState, useCallback, useEffect } from "react";
import { IFlight } from "@vmosolutions/oc-interfaces";
import _ from "lodash";

interface IOpsLinkFlights {
  id: string;
  headerHeight: number;
  trackedFlights: IFlight[];
  setTrackedFlights: React.Dispatch<React.SetStateAction<IFlight[]>>;
  selectedFlights: IFlight[];
  setSelectedFlights: React.Dispatch<React.SetStateAction<IFlight[]>>;
}

const OCOpsLinkFlights = styled(Box)(({ theme }) => ({
  padding: "5px",
  height: "100%",
  "& .chevronHeader": {
    width: "100%",
    height: "50px",
    display: "grid",
    justifyContent: "end",
  },
}));

export default function OpsLinkFlights(props: IOpsLinkFlights): JSX.Element {
  const { id, headerHeight, trackedFlights, setTrackedFlights, selectedFlights, setSelectedFlights } = props;
  const [isOpen, setIsOpen] = useState<boolean>(true);

  const toggleOpen = useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen]);

  const onClick = useCallback(
    (flight: IFlight) => {
      const tempSelectedFlights = _.cloneDeep(selectedFlights);
      const currentFlightIndex = tempSelectedFlights.findIndex(
        (trackedFlight: IFlight) => trackedFlight._id === flight._id
      );
      if (currentFlightIndex >= 0) {
        tempSelectedFlights.splice(currentFlightIndex, 1);
      } else {
        tempSelectedFlights.push(flight);
      }
      setSelectedFlights(tempSelectedFlights);
    },
    [trackedFlights, selectedFlights]
  );

  return (
    <OCOpsLinkFlights>
      <Box className="chevronHeader">
        <IconButton disabled onClick={toggleOpen} sx={{ height: "24px", width: "24px" }}>
          {isOpen ? <ChevronLeftIcon /> : <ChevronRightIcon />}
        </IconButton>
      </Box>
      {isOpen ? (
        <Grid
          container
          direction="column"
          spacing={1}
          sx={{
            maxHeight: `calc(97vh - ${headerHeight}px)`,
            padding: "0 5px",
            flexWrap: "nowrap",
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          {trackedFlights &&
            trackedFlights.map((flight, index) => {
              return (
                <Grid item key={flight._id}>
                  <FlightCard
                    selectedFlights={selectedFlights}
                    trackedFlights={trackedFlights}
                    setTrackedFlights={setTrackedFlights}
                    onClick={() => onClick(flight)}
                    flight={flight}
                  />
                </Grid>
              );
            })}
          <Grid item>
            <FlightDropCard
              trackedFlights={trackedFlights}
              setTrackedFlights={setTrackedFlights}
              selectedFlights={selectedFlights}
              setSelectedFlights={setSelectedFlights}
            />
          </Grid>
        </Grid>
      ) : (
        <></>
      )}
    </OCOpsLinkFlights>
  );
}
